<template>
    <v-alert v-if="announcement.enabled" :icon="getIcon" prominent text :color="getType">
        {{ announcement.text }}
    </v-alert>
</template>

<script>
export default {
    name: 'home-announcement',
    props: {
        announcement: {
            required: true
        }
    },
    computed: {
        getIcon() {
            if (this.announcement.class == "High") {
                return 'mdi-alert-octagon';
            } else if (this.announcement.class == "Moderate") {
                return 'mdi-alert-circle';
            } else if (this.announcement.class == "Low") {
                return 'mdi-check-circle';
            }

            return 'mdi-information';
        },
        getType() {
            if (this.announcement.class == "High") {
                return '#f64e60';
            } else if (this.announcement.class == "Moderate") {
                return '#ffb822';
            } else if (this.announcement.class == "Low") {
                return '#1dc9b7';
            }

            return '#5867dd';
        }
    }
}
</script>

<style scoped>
.v-alert {
    font-family: 'Poppins', sans-serif !important;
}
</style>